/** 常量文件,用于存储常用常量 */
export default {
  content: '首页',
}
